<template>
    <div class="header-challenge-requests">
        <h1 class="header-challenge-requests__h1">{{ textH1 }}</h1>
        <p class="header-challenge-requests__desc">{{ textDesc }}</p>
    </div>
</template>

<script>
    /*
        +---+---+---+--+---+--+---+---+---+---+---+
    
                    Component Imports
    
        +---+---+---+--+---+--+---+---+---+---+---+
    */


    /*
        +---+---+---+--+---+--+---+---+---+---+---+
    
                    Component Instance
    
        +---+---+---+--+---+--+---+---+---+---+---+
    */
    export default {
        props: {
            textH1: {
                type: String,
                default: 'Lorem Ipsum',
            },
            textDesc: {
                type: String,
                default: 'Lorem ipusm dolor sit amet.',
            },
        },
    };
</script>

<style scoped src="@/css/components/header-challenge-requests.css"></style>